import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import ddt from '@wix/da-ddt';
import { SessionContext } from '../SessionContext';
const filteredErrors = [
    {
        filter: /Failed to execute 'removeChild'/i
    },
    {
        filter: /Failed to execute 'insertBefore'/i
    },
    {
        filter: /The object can not be found here/i
    },
    {
        filter: /IntersectionObserver/i
    },
    {
        filter: /ResizeObserver/i
    },
    {
        filter: /Loading chunk/i
    },
    {
        filter: /Loading CSS chunk/i
    },
    {
        filter: /access dead object/i
    },
    {
        filter: /Permission denied to access object/i
    },
    {
        filter: /invariant=306/i,
        component: [
            'ChatInit'
        ]
    },
    {
        filter: /Intl is not defined|Can't find variable: Intl/i
    },
    {
        filter: /Object\.entries is not a function/i
    },
    {
        filter: /Object\.values is not a function/i
    },
    {
        filter: /not a child of this node/i
    },
    {
        filter: /proxyDocumentStyleSheets/i
    },
    {
        filter: /Failed to construct 'Worker'/i
    },
    {
        filter: /cannot be created in a document with origin/i
    },
    {
        filter: /Blocked attempt to use history/i
    },
    {
        filter: /Object.fromEntries/i
    }
];
const stackFilters = [
    /user-script/,
    /chrome-extension/
];
export function shouldLogError(error) {
    let shouldLog = true;
    for (const fe of filteredErrors){
        if (fe.filter.test(error && error.message)) {
            var _fe_component;
            if (Array.isArray(fe.component) && !((_fe_component = fe.component) === null || _fe_component === void 0 ? void 0 : _fe_component.includes(this.props.debugComponent))) {
                continue; // allows filtering for specific components
            }
            shouldLog = false;
            break;
        }
    }
    for (const sf of stackFilters){
        if (sf.test(error && error.stack)) {
            shouldLog = false;
            if (/user-script|chrome-extension/.test(error && error.stack)) {
                alert('Your user script or extension crashed, please reload the page.');
            }
        }
    }
    return shouldLog;
}
class ErrorBoundary extends React.Component {
    static getDerivedStateFromError() {
        return {
            isError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'development' && errorInfo && errorInfo.componentStack) {
            // eslint-disable-next-line no-console
            console.error(errorInfo.componentStack); // tslint:disable-line
        }
        if (!shouldLogError(error)) {
            return;
        }
        ddt.alert('fatal', `Error Boundary Caught: ${error && error.message || 'unknown'}`, [
            'fatal',
            this.props.debugComponent
        ], {
            stacktrace: error && error.stack,
            component: this.props.debugComponent,
            session: this.props.sessionContext
        });
        if (process.env.NODE_ENV === 'test') {
            throw error;
        }
    }
    render() {
        if (this.state && this.state.isError) {
            if (this.props.hideOnFail) {
                return null;
            }
            return /*#__PURE__*/ React.createElement("div", {
                className: this.props.className,
                style: _object_spread({
                    font: 'var(--f-16-reg)',
                    border: '4px solid var(--g-error-primary)',
                    borderRadius: '4px',
                    padding: '20px',
                    color: 'var(--g-error-primary)',
                    textAlign: 'center'
                }, this.props.style)
            }, this.props.humanError && /*#__PURE__*/ React.createElement("p", null, this.props.humanError), !this.props.humanError && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
                style: {
                    font: 'var(--f-14-reg)'
                }
            }, "E_GURU_MEDITATION"), /*#__PURE__*/ React.createElement("h3", {
                style: {
                    font: 'var(--h6)',
                    marginBottom: '10px'
                }
            }, "Something's gone wrong on our end"), /*#__PURE__*/ React.createElement("p", null, "We're having a technical issue. Try reloading the page.", /*#__PURE__*/ React.createElement("br", null), "If this keeps happening, please contact Customer Support.")));
        }
        return this.props.children;
    }
}
const withContext = (props)=>/*#__PURE__*/ React.createElement(SessionContext.Consumer, null, (contextProps)=>/*#__PURE__*/ React.createElement(ErrorBoundary, _object_spread_props(_object_spread({}, props), {
            sessionContext: contextProps
        })));
withContext.displayName = 'ErrorBoundary';
export default withContext;

//# sourceMappingURL=ErrorBoundary.js.map